import { useCallback } from "react";

import type { Permission } from "@lib/permissionConstants";

import { useResolvePermission } from "@services/permissions";
import { developerTeamsWithPermission } from "@services/permissions/useDeveloperTeamsWithPermission/developerTeamsWithPermission";
import { useAppGroupId } from "@services/useAppGroupId";
import { useDeveloper } from "@services/useDeveloper";
import type { DeveloperWithPermissionMap } from "@services/useDeveloper/types";

export const useDeveloperTeamsWithPermission = () => {
  const { data: developer } = useDeveloper();
  const permissionMap = (developer as DeveloperWithPermissionMap).permissionMap;
  const companyId = developer.company_id;
  const appGroupId = useAppGroupId();
  const resolvePermission = useResolvePermission();

  return useCallback(
    (permission: Permission) => {
      // Resolve the permission we're checking for to what needs to be checked based on state of granular
      // permission migration.
      const permissionToCheck = resolvePermission(permission);

      return developerTeamsWithPermission(permissionMap, companyId, appGroupId, permissionToCheck);
    },
    [resolvePermission, permissionMap, companyId, appGroupId]
  );
};
